<!-- <div class="alert-container">
    <alert-tabs [selectedIndex]="alertvarservice.alertselectedIndex" (selectedIndexChange)="changeTab($event)" [isProgress]="isProgress">
        <tab label="Alert Overview">
            <ng-container *ngIf="alertvarservice.sharedService.dashboard_preview.alert_dashboard">
                <ng-container *ngIf="dashboardExists && !dashboardSpinner">
                    <app-dashboard-preview [data]="dbData" [dbname]="dbname" overviewMode=true></app-dashboard-preview>
                </ng-container>
                <ng-container *ngIf="dashboardSpinner">
                    <div class="spinner-wrapper">
                        <mat-spinner class="loading light-text primary-text" diameter="15"></mat-spinner>
                    </div>
                </ng-container>
            </ng-container>
            <ng-container *ngIf="!alertvarservice.sharedService.dashboard_preview.alert_dashboard">
                <div class="dashboard-error">
                    <div>
                        <img src="assets/alerts/empty-data.svg">
                    </div>
                    <div>
                        <p>{{alertvarservice.titles.alertTitles.no_result}}</p>
                    </div>
                </div>
            </ng-container>
        </tab>
        <tab label="Explore Alerts">
            <div class="alert-wrapper">
                <div class="side_nav_container" *ngIf="!alertvarservice.factSheetOpened">
                    <app-summary-table></app-summary-table>

                </div>
                <app-fact-sheet *ngIf="alertvarservice.factSheetOpened"></app-fact-sheet>
            </div>
        </tab>
        <tab label="Alert & Ticketing">
            <div class="alert-wrapper">
                <ticketing></ticketing>
            </div>
        </tab>
    </alert-tabs>
</div> -->

<div class="alert-wrapper p-7" *ngIf="!alertvarservice.factSheetOpened">
    <div class="header border-light-bottom pb-5">
        <p class="primary-text hide content-s">{{alertvarservice.landingTitles.alert_title}}</p>
        <div class="title_options">
            <h2 class="primary-text lightest-text">{{alertvarservice.landingTitles.alert_title}}</h2>
            <div class="right-section">
                <mat-icon class="enable-action tooltip-enable" position="left" tooltip="Home" (click)="navIconclick(crumpService.homeIcon)">home</mat-icon>
                <ng-container *ngIf="!(sharedService.$sidebarExpanded | async)">
                    <mat-icon class=" enable-action tooltip-enable" position="left" [tooltip]="(sharedService.$sidebarExpanded | async) ? alertvarservice.landingTooltip.collapse_nav :alertvarservice.landingTooltip.expand_nav" (click)="sidebarClick()">menu</mat-icon>
                </ng-container>
                <ng-container *ngIf="(sharedService.$sidebarExpanded | async)">
                    <mat-icon class="enable-action tooltip-enable" position="left" [tooltip]="(sharedService.$sidebarExpanded | async) ? alertvarservice.landingTooltip.collapse_nav : alertvarservice.landingTooltip.expand_nav" (click)="sidebarClick()">menu_open</mat-icon>
                </ng-container>
            </div>
        </div>
        <p class="primary-text lighter-text content-m">{{alertvarservice.landingTitles.alert_context}}</p>
    </div>
    <tabs-division [selectedIndex]="alertvarservice.alertselectedIndex" (selectedIndexChange)="changeTab($event)" [isProgress]="isProgress">
        <tab label="Alerts">
            <app-alert-landing></app-alert-landing>
        </tab>
        <tab label="Auto-Close Rules" disable="true"></tab>
        <tab label="Auto-Investigate" disable="true"></tab>
    </tabs-division>
</div>

<app-fact-sheet *ngIf="alertvarservice.factSheetOpened"></app-fact-sheet>